import { render, staticRenderFns } from "./FeSubmitButton.vue?vue&type=template&id=722d463c&"
import script from "./FeSubmitButton.vue?vue&type=script&lang=js&"
export * from "./FeSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports